import {
  IPayerPayeePayerOwnedData,
  RequirementStatus,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import {
  IPayerPayeeW9Data,
  PayeeTaxDocumentSharePermission,
  PayerPayeeStatus,
  PaymentRequirementStrategy
} from "@wingspanhq/payments/dist/interfaces/payerPayee";
import {
  IMember,
  INewUser,
  ISharedMember,
  ISharedUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { ListRequestQuery } from "../../../utils/serviceHelper";
import { ISearchablePayerPayeeEngagement } from "../payer";
import { serviceSearch } from "../service";
import {
  PayerPayeeEngagementSearchableStatus,
  PayerPayeeSearchableTinStatus
} from "../types";

export interface IPayeeRow {
  createdAt: Date;
  updatedAt: Date;
  payeeId: string;
  searchableStatus: PayerPayeeEngagementSearchableStatus;
  payerId: string;
  payer?: {
    member: IMember;
    user: INewUser;
  };

  payerOwnedData: IPayerPayeePayerOwnedData;
  payeeOwnedData: {
    status: PayerPayeeStatus; //IPayerPayeePayeeOwnedData["status"],
    shareTaxDocument: PayeeTaxDocumentSharePermission; //IPayerPayeePayeeOwnedData["shareTaxDocument"],
    autoPayRequirement: PaymentRequirementStrategy; // IPayerPayeePayeeOwnedData["autoPayRequirement"]
    payeeW9Data?: IPayerPayeeW9Data;
  };

  engagements: ISearchablePayerPayeeEngagement[];
  user: ISharedUser;
  member: ISharedMember;
  searchableTinStatus: PayerPayeeSearchableTinStatus;
}

export type PayeeRowsQueryFilter = {
  searchString?: string;
  searchableStatus?:
    | PayerPayeeEngagementSearchableStatus
    | {
        "!="?: PayerPayeeEngagementSearchableStatus;
        in?: PayerPayeeEngagementSearchableStatus[];
      };
  "engagements.engagementId"?:
    | string
    | {
        in?: string[];
      };

  "engagements.payerPayeeEngagementId"?: string;
  "engagements.requirements.requirementId"?: string;
  "engagements.requirements.requirementDefinitionId"?: string;

  "engagements.requirements.requirementType"?:
    | RequirementType
    | {
        "!="?: RequirementType;
        in?: RequirementType[];
      };

  "engagements.requirements.status"?:
    | RequirementStatus
    | {
        "!="?: RequirementStatus;
        in?: RequirementStatus[];
      };

  "payerOwnedData.status"?:
    | PayerPayeeStatus
    | {
        "!="?: PayerPayeeStatus;
        in?: PayerPayeeStatus[];
      };
  "payerOwnedData.autoPayStrategy"?:
    | PaymentRequirementStrategy
    | {
        "!="?: PaymentRequirementStrategy;
        in?: PaymentRequirementStrategy[];
      };
  "payeeOwnedData.shareTaxDocument"?:
    | PayeeTaxDocumentSharePermission
    | {
        "!="?: PayeeTaxDocumentSharePermission;
        in?: PayeeTaxDocumentSharePermission[];
      };
  "labels.bulkBatchId"?:
    | string
    | {
        in?: string[];
      };
  payerId?:
    | string
    | {
        "!="?: string;
        in?: string[];
      };

  payeeId?:
    | string
    | {
        "!="?: string;
        in?: string[];
      };

  "requirements.requirementType"?:
    | RequirementType
    | {
        "!="?: RequirementType;
        in?: RequirementType[];
      };

  "requirements.requirementId"?: string;
  "requirements.requirementDefinitionId"?: string;

  "requirements.status"?:
    | RequirementStatus
    | {
        "!="?: RequirementStatus;
        in?: RequirementStatus[];
      };

  "requirements.payerOverrideStatus"?:
    | RequirementStatus
    | {
        "!="?: RequirementStatus;
        in?: RequirementStatus[];
      };

  "requirements.isPendingBackgroundCheck"?: string;
  "requirements.isProcessingBackgroundCheck"?: string;
  "requirements.isFailedBackgroundCheck"?: string;
  "requirements.isPendingPayerSignature"?: string;
  "requirements.isPendingPayeeSignature"?: string;
  "requirements.isIncomplete"?: string;
  "requirements.isComplete"?: string;
  "requirements.isPendingReview"?: string;
  "requirements.isRejectedReview"?: string;
  "requirements.isApprovedReview"?: string;

  [key: string]:
    | undefined
    | string
    | boolean
    | {
        in?: string[];
      }
    | {
        "!="?: string;
      }
    | {
        contains?: string;
      };
};

export type PayeeRowsQuerySort = {
  updatedAt?: "asc" | "desc";
};

export type PayeeRowsQuery = ListRequestQuery<
  PayeeRowsQueryFilter,
  PayeeRowsQuerySort
>;

export const getPayeeRows = async (
  params?: PayeeRowsQuery,
  xWingspanExpansion?: string
): Promise<IPayeeRow[]> => {
  const response = await serviceSearch.get("/payee-row", {
    params,
    ...(xWingspanExpansion
      ? {
          headers: {
            "x-wingspan-expansion": xWingspanExpansion
          }
        }
      : {})
  });

  return response.data;
};

export type IPayeeSearchRowsSummary = {
  listSize: number;
};

export const getPayeeRowsSummary = async (
  params?: PayeeRowsQuery,
  xWingspanExpansion?: string
): Promise<IPayeeSearchRowsSummary> => {
  const { headers } = await serviceSearch.get(`/payee-row`, {
    params,
    headers: {
      "X-WS-Get-List-Summary": "true",
      ...(xWingspanExpansion
        ? {
            "x-wingspan-expansion": xWingspanExpansion
          }
        : {})
    }
  });

  return {
    listSize: Number(headers["x-ws-list-size"])
  };
};
